import { ArticleHeading3, ArticleHeading4, UIText1, Button, Bullet16, Label } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './DescriptionBuyAnalyticsBlock.css';
import { CONTENT_ITEMS } from './constants';
import { IDescriptionBuyAnalyticsBlockProps } from './types';
import { IBuyAnalyticsBlockProps } from '../../types';
import { ChartIcon } from '../ChartIcon';

export const DescriptionBuyAnalyticsBlock: React.VFC<IBuyAnalyticsBlockProps & IDescriptionBuyAnalyticsBlockProps> = ({
  buildingName,
  reportPrice,
  onBuyClick,
}) => {
  const contentList = CONTENT_ITEMS.map((items, index) => {
    const list = items.map((item, index) => {
      return (
        <div key={item + index} className={styles['content-item']}>
          <div className={styles['bullet-wrapper']}>
            <Bullet16 color="gray_icons_100" />
          </div>
          <UIText1>{item}</UIText1>
        </div>
      );
    });
    const column = (
      <div key={index} className={styles['content-column']}>
        {list}
      </div>
    );

    return column;
  });

  return (
    <div className={styles['container']}>
      <div className={styles['top-block']}>
        <div className={styles['icon-wrapper']}>
          <ChartIcon />
        </div>
        <div className={styles['title-wrapper']}>
          <div className={styles['title']}>
            <ArticleHeading3>Аналитический отчёт по зданию</ArticleHeading3>
            <div className={styles['label-wrapper']}>
              <Label color="error_100" background="rgba(255, 31, 52, 0.1)">
                Новое
              </Label>
            </div>
          </div>
          {buildingName && (
            <div className={styles['address-wrapper']}>
              <UIText1>{buildingName}</UIText1>
            </div>
          )}
        </div>
      </div>
      <div className={styles['content']}>
        <div className={styles['content-title']}>
          <ArticleHeading4>Что входит в PDF-отчёт</ArticleHeading4>
        </div>
        <div className={styles['content-list']}>{contentList}</div>
      </div>
      <Button theme="fill_primary" size="XS" onClick={onBuyClick}>
        Купить отчёт за {reportPrice}
      </Button>
    </div>
  );
};

DescriptionBuyAnalyticsBlock.displayName = 'DescriptionBuyAnalyticsBlock';
